module.exports = __webpack_public_path__ + "img/0027.a45dd29e.png";